import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import SuppliesPage from './pages/SuppliesPage';
import MarketingPage from './pages/MarketingPage';
import DocumentsPage from './pages/DocumentsPage';
import CustomOrderPage from './pages/CustomOrderPage';
import AccountPage from './pages/AccountPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();
  const [page, setPage] = useState('dashboard');

  if (loading) return (
    <div className="loading-screen">
      <div className="loading-logo">
        <div style={{ fontSize: 24, fontWeight: 700, color: '#10497c' }}>Neurogenx</div>
        <div className="loading-spinner"></div>
      </div>
    </div>
  );

  if (!user) return <LoginPage />;

  const pages = {
    dashboard: <Dashboard setCurrentPage={setPage} />,
    supplies: <SuppliesPage />,
    orders: <OrderHistoryPage setCurrentPage={setPage} />,
    marketing: <MarketingPage />,
    documents: <DocumentsPage />,
    'custom-order': <CustomOrderPage />,
    account: <AccountPage />,
  };

  return <Layout currentPage={page} setCurrentPage={setPage}>{pages[page] || pages.dashboard}</Layout>;
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>;
}
